import { getTristatePolygons } from '../api'

const initialState = {
    isLoading: true,
    polygons: []
}

export const paths = ({
    state: initialState,
    reducers: {
        setGeoPaths(state, paths) {
            return {
                ...state,
                polygons: paths,
                isLoading: false,
            }
        }
    },
    effects: {
        async loadGeoPaths() {
            const paths = await getTristatePolygons()
            this.setGeoPaths(paths)
        }
    }

})
